/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BazaarvoiceContainer } from './container';

export function BazaarvoiceInlineRating({ productId, redirectUrl }: { productId: string; redirectUrl?: string }) {
    if (!productId) {
        return null;
    }

    return (
        <div data-testid="bazaarvoice-inline-rating">
            <BazaarvoiceContainer show="inline_rating" productId={productId} redirectUrl={redirectUrl} seo={false} />
        </div>
    );
}
